const isUserFriendlyEmail =
  (problemEmails: Array<string>) => (value: string) => {
    if (!problemEmails) return true;
    const regArray = problemEmails.map((el) => new RegExp(`@${el}$`));
    return !regArray.find((el) => el.test(value));
  };

const mailValidator = (value: string) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !!value?.match(regex) || false;
};

export { isUserFriendlyEmail, mailValidator };



// WEBPACK FOOTER //
// ./src/tools/validators/emailValidators.ts